import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    return (
        <EfImg
            pc="https://websiteoss.ecoflow.com/upload/image/1725594353395/pc_ksp_07.jpg"
            pad="https://websiteoss.ecoflow.com/upload/image/1725594353395/pc_ksp_07.jpg"
            h5="https://websiteoss.ecoflow.com/upload/image/1726639175108/m_ksp_07.jpg"
        />
    );
}
